import type {ReactAction} from '@netx/core/bootstrap';
import {performAction} from '@netx/core/lib/utils';
import {faTable} from '@fortawesome/pro-solid-svg-icons';
import {datamanagerAuthorized} from '../enablers/datamanagerAuthorized';
import {datamanagerEnabled} from '../enablers/datamanagerEnabled';
import {DataSetsManageLabel} from '../locales';

export const dataSetActionDataSetsManageRouteIcon = faTable;

/**
 * Route to data sets management
 * @param params
 * @returns Action
 */
export const dataSetActionDataSetsManageRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'data-sets-route',
	cb: () => performAction('dataSet:dataSets:route'),
	enableTest: () => datamanagerAuthorized() && datamanagerEnabled(),
	icon: dataSetActionDataSetsManageRouteIcon,
	get label() {
		return DataSetsManageLabel.ROUTE;
	},
	routeMatch: /^dataset\/datasets(\/?)/,
	...params,
});
